import React, { useRef } from 'react';
import './notifications.css';
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Header/Header";
import NotificationsHeader from "../../components/PagesHeaders/NotificationsHeader/NotificationsHeader";
import { dropdownAction, notificationsFormAction } from "../../redux/rootReducer";
import { getUsersForSubscriptionSagaAction, sendMessagesSagaAction } from "../../redux/sagaActions";
import TextareaAutosize from "react-textarea-autosize";

const Notifications = () => {
    const dispatch = useDispatch();
    const notifications_form = useSelector(state => state.notifications_form);
    const dropdown = useSelector(state => state.dropdown);
    const subscription_types = useSelector(state => state.subscription_types);

    const timer = useRef(0);

    const getUsers = text => {

        if (timer.current) clearTimeout(timer.current);

        if (!text.trim()) {
            dispatch(notificationsFormAction({
                ...notifications_form,
                user: { id: '', name: '' },
                users: [],
                userInput: ''
            }));
            return false;
        }

        // Делаем задержку для набора текста
        timer.current = setTimeout(() => {
            dispatch(getUsersForSubscriptionSagaAction({ text, type: 'notification' }));
        }, 500);
    };

    return (
        <>
            <Header component={ <NotificationsHeader/> }/>
            <div className="page">
                <div className="notifications">
                    <div className="table__header">
                        <div className="table__caption">Рассылка сообщений</div>
                    </div>
                    <div className="notifications__field">
                        <div className="input__caption input__caption--required">Тип рассылки</div>
                        <div className="dropdown notifications__type">
                            <div className="input input--tick input--inactive"
                                 onClick={ () => dispatch(dropdownAction('notification_type')) }
                            >
                                { notifications_form.type.name }
                            </div>
                            <div className={ `dropdown__items ${ dropdown === 'notification_type' ? 'dropdown__items--open' : '' }` }>
                                {/*<div*/}
                                {/*    className="dropdown__item"*/}
                                {/*    onClick={ () => {*/}
                                {/*        dispatch(notificationsFormAction({*/}
                                {/*            ...notifications_form,*/}
                                {/*            type: { id: 'email', name: 'Email' }*/}
                                {/*        }));*/}
                                {/*        dispatch(dropdownAction(null));*/}
                                {/*    } }*/}
                                {/*>*/}
                                {/*    { 'Email' }*/}
                                {/*</div>*/}
                                <div
                                    className="dropdown__item"
                                    onClick={ () => {
                                        dispatch(notificationsFormAction({
                                            ...notifications_form,
                                            type: { id: 'push', name: 'Push - сообщения' }
                                        }));
                                        dispatch(dropdownAction(null));
                                    } }
                                >
                                    { 'Push - сообщения' }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="notifications__addressees">
                        <div className="notifications__field">
                            <div className="input__caption input__caption--required">Кому отправить</div>
                            <div className="dropdown">
                                <div className="input input--tick"
                                     onClick={ () => dispatch(dropdownAction('notification_addressees')) }
                                >
                                    { notifications_form.addressees.name }
                                </div>
                                <div className={ `dropdown__items ${ dropdown === 'notification_addressees' ? 'dropdown__items--open' : '' }` }>
                                    <div
                                        className="dropdown__item"
                                        onClick={ () => {
                                            dispatch(notificationsFormAction({
                                                ...notifications_form,
                                                addressees: { id: 'user', name: 'Посетитель' }
                                            }));
                                            dispatch(dropdownAction(null));
                                        } }
                                    >
                                        { 'Посетитель' }
                                    </div>
                                    <div
                                        className="dropdown__item"
                                        onClick={ () => {
                                            dispatch(notificationsFormAction({
                                                ...notifications_form,
                                                addressees: { id: 'without_workout', name: 'Новый посетитель' }
                                            }));
                                            dispatch(dropdownAction(null));
                                        } }
                                    >
                                        { 'Новый посетитель' }
                                    </div>
                                    <div className="dropdown__item"
                                        onClick={ () => {
                                            dispatch(notificationsFormAction({
                                                ...notifications_form,
                                                addressees: { id: 'gender', name: 'Указать пол' }
                                            }));
                                            dispatch(dropdownAction(null));
                                        } }
                                    >
                                        { 'Указать пол' }
                                    </div>
                                    <div
                                        className="dropdown__item"
                                        onClick={ () => {
                                            dispatch(notificationsFormAction({
                                                ...notifications_form,
                                                addressees: { id: 'not_been_x_month', name: 'Не был X дней' }
                                            }));
                                            dispatch(dropdownAction(null));
                                        } }
                                    >
                                        { 'Не был X дней' }
                                    </div>
                                    <div
                                        className="dropdown__item"
                                        onClick={ () => {
                                            dispatch(notificationsFormAction({
                                                ...notifications_form,
                                                addressees: { id: 'birthday', name: 'День рождения' }
                                            }));
                                            dispatch(dropdownAction(null));
                                        } }
                                    >
                                        { 'День рождения' }
                                    </div>
                                    <div
                                        className="dropdown__item"
                                        onClick={ () => {
                                            dispatch(notificationsFormAction({
                                                ...notifications_form,
                                                addressees: { id: 'type_workout', name: 'Посещал занятие' }
                                            }));
                                            dispatch(dropdownAction(null));
                                        } }
                                    >
                                        { 'Посещал занятие' }
                                    </div>
                                    <div
                                        className="dropdown__item"
                                        onClick={ () => {
                                            dispatch(notificationsFormAction({
                                                ...notifications_form,
                                                addressees: { id: 'all', name: 'Всем' }
                                            }));
                                            dispatch(dropdownAction(null));
                                        } }
                                    >
                                        { 'Всем' }
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            notifications_form.addressees.id === 'user'
                            ?
                                <div className="notifications__field">
                                    <div className="input__caption input__caption--require">Посетитель</div>
                                    <div className="dropdown">
                                        <input type="text" className="input"
                                               value={ notifications_form?.userInput || notifications_form.user.name }
                                               onInput={ event => {
                                                   dispatch(notificationsFormAction({
                                                       ...notifications_form,
                                                       userInput: event.target.value,
                                                       user: { id: '', name: '' }
                                                   }));
                                                   // Получение с сервера списка всех пользователей, с совпадением по email или телефону
                                                   getUsers(event.target.value);
                                               } }
                                        />
                                        <div className={ `dropdown__items ${ notifications_form.userInput ? 'dropdown__items--open' : false }` }>
                                            {
                                                notifications_form.users?.length
                                                    ? notifications_form.users.map(elem => {
                                                        return (
                                                            <div className="dropdown__item" key={ elem.id }
                                                                 onClick={ () => {
                                                                     dispatch(notificationsFormAction({
                                                                         ...notifications_form,
                                                                         user: elem,
                                                                         userInput: ''
                                                                     }));
                                                                 } }
                                                            >{ elem.name }</div>
                                                        );
                                                    })
                                                    : <div className="dropdown__item dropdown__item--inactive">{ `Ничего не найдено` }</div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            : notifications_form.addressees.id === 'gender'
                            ?
                                <div className="notifications__field">
                                    <div className="input__caption input__caption--require">Укажите пол</div>
                                    <div className="dropdown"
                                         onClick={ () => dropdown === 'gender' ? dispatch(dropdownAction(null)) : dispatch(dropdownAction('gender')) }
                                    >
                                        <div className="input input--tick">{ notifications_form.gender.name }</div>
                                        <div className={ `dropdown__items ${ dropdown === 'gender' ? 'dropdown__items--open' : false }` }>
                                            <div className="dropdown__item"
                                                onClick={ () => dispatch(notificationsFormAction({
                                                    ...notifications_form,
                                                    gender: { id: 'male', name: 'Мужской' }
                                                })) }
                                            >Мужской</div>
                                            <div className="dropdown__item"
                                                onClick={ () => dispatch(notificationsFormAction({
                                                    ...notifications_form,
                                                    gender: { id: 'female', name: 'Женский' }
                                                })) }
                                            >Женский</div>
                                        </div>
                                    </div>
                                </div>
                            : notifications_form.addressees.id === 'not_been_x_month'
                            ?
                                <div className="notifications__field">
                                    <div className="input__caption input__caption--require">Количество дней</div>
                                    <div className="dropdown">
                                        <input type="text" className="input"
                                               value={ notifications_form?.months }
                                               onInput={ event => {
                                                   dispatch(notificationsFormAction({
                                                       ...notifications_form,
                                                       months: event.target.value
                                                   }));
                                               } }
                                        />
                                    </div>
                                </div>
                            : notifications_form.addressees.id === 'type_workout'
                            ?
                                <div className="notifications__field">
                                    <div className="input__caption input__caption--require">Тип тренировки</div>
                                    <div className="dropdown"
                                         onClick={ () => dropdown === 'type_workout' ? dispatch(dropdownAction(null)) : dispatch(dropdownAction('type_workout')) }
                                    >
                                        <div className="input input--tick">{ notifications_form.type_workout.name }</div>
                                        <div className={ `dropdown__items ${ dropdown === 'type_workout' ? 'dropdown__items--open' : false }` }>
                                            {
                                                subscription_types?.map(elem => {
                                                    return (
                                                        <div className="dropdown__item"
                                                             key={ elem.id }
                                                             onClick={ () => dispatch(notificationsFormAction({
                                                                 ...notifications_form,
                                                                 type_workout: { id: elem.id, name: elem.name }
                                                             })) }
                                                        >{ elem.name }</div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            : false
                        }
                    </div>
                    <div className="notifications__field">
                        <div className="input__caption">Заголовок</div>
                        <input
                            className="input"
                            type={ 'text' }
                            value={ notifications_form.title }
                            onInput={ event => dispatch(notificationsFormAction({
                                ...notifications_form,
                                title: event.target.value
                            })) }
                        />
                    </div>
                    <div className="notifications__field">
                        <div className="input__caption input__caption--required">Текст сообщения</div>
                        <TextareaAutosize
                            className="input input--textarea"
                            value={ notifications_form.message }
                            onInput={ event => dispatch(notificationsFormAction({
                                ...notifications_form,
                                message: event.target.value
                            })) }
                        />
                    </div>
                    <div className="notifications__field">
                        <div className="button" onClick={ () => {
                            dispatch(sendMessagesSagaAction({
                                type: notifications_form.type.id,
                                addressees: notifications_form.addressees.id,
                                user: notifications_form.user.id,
                                title: notifications_form.title,
                                message: notifications_form.message,
                                months: notifications_form.months,
                                gender: notifications_form.gender.id,
                                type_workout: notifications_form.type_workout.id
                            }));
                        } }>Отправить</div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Notifications;